import { render } from "./SloganSectionComponent.vue?vue&type=template&id=d000ed4c&scoped=true"
import script from "./SloganSectionComponent.vue?vue&type=script&lang=js"
export * from "./SloganSectionComponent.vue?vue&type=script&lang=js"

import "./SloganSectionComponent.vue?vue&type=style&index=0&id=d000ed4c&lang=css"
import "./SloganSectionComponent.vue?vue&type=style&index=1&id=d000ed4c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d000ed4c"]])

export default __exports__